"use client";

import { cn } from "@/utils";

type ChartScaleToggleProps = {
  logScale: boolean;
  onChange: (logScale: boolean) => void;
};

export function ChartScaleToggle({ logScale, onChange }: ChartScaleToggleProps) {
  return (
    <div
      className="flex rounded-lg border border-white/10 bg-surface-400/40 p-0.5 text-2xs"
      role="group"
      aria-label="Y-axis scale"
    >
      <button
        type="button"
        onClick={() => onChange(true)}
        className={cn(
          "rounded-md px-2.5 py-1.5 font-medium transition-colors",
          logScale ? "bg-surface-300 text-white" : "text-muted hover:text-white",
        )}
      >
        Log
      </button>
      <button
        type="button"
        onClick={() => onChange(false)}
        className={cn(
          "rounded-md px-2.5 py-1.5 font-medium transition-colors",
          !logScale ? "bg-surface-300 text-white" : "text-muted hover:text-white",
        )}
      >
        Linear
      </button>
    </div>
  );
}

export default ChartScaleToggle;
